module.exports = __webpack_public_path__ + "static/media/fuel-system-cleaning.947b2bcd.svg";